// eslint-disable-next-line no-unused-vars
import * as React from 'react'
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card.jsx'
import { XCircle } from 'lucide-react'
import { Button } from '@/components/ui/button.jsx'
import { useRouter } from '@tanstack/react-router'

export function Page404() {
  const router = useRouter()
  const searchParams = new URLSearchParams(router.state.location.search) // Parse the search query

  const title = searchParams.get('title')
  const message = searchParams.get('message')
  return (
    <div className="container grid h-svh max-w-none flex-col items-center justify-center bg-primary-foreground px-0">
      <Card className="w-[480px]">
        <CardHeader>
          <div className="flex items-center gap-2">
            <XCircle className="h-8 w-8 text-destructive" />
            <CardTitle className="text-2xl text-red-500">
              {title || '404 - Not Found'}
            </CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            {message ||
              'Bạn có chắc chắn mình vừa truy cập đúng đường link? Vui lòng thử lại!'}
          </p>
        </CardContent>
        <CardFooter>
          <Button asChild className="w-full">
            <a href="/">Quay lại trang chủ</a>
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
